import { Button, ButtonProps, Stack } from 'react-bootstrap';

import { ButtonVariant } from 'react-bootstrap/esm/types';
import classNames from 'classnames';

export interface IIconButtonProps extends ButtonProps {
    buttonCssClass?: string;
    buttonStyle?: React.CSSProperties;
    buttonTitle?: string;
    disabled?: boolean;
    icon?: string | React.ReactNode;
    onClick: (event: React.MouseEvent<HTMLButtonElement> | undefined) => void;
    size?: 'sm' | 'lg';
    buttonTabIndex?: number;
    text?: string;
    variant?: ButtonVariant;
}
export function IconButton(props: IIconButtonProps) {
    const { icon } = props;

    return (
        <Button
            onClick={props.onClick}
            className={classNames(props.buttonCssClass)}
            disabled={props.disabled}
            variant={props.variant ?? ''}
            size={props.size}
            style={props.buttonStyle}
            title={props.buttonTitle}
            tabIndex={props.buttonTabIndex}
        >
            <Stack
                direction="horizontal"
                gap={2}
                style={{ alignItems: 'center', whiteSpace: 'nowrap' }}
            >
                {typeof icon === 'string' ? (
                    <i className={icon} style={{ color: 'inherit' }} />
                ) : (
                    icon
                )}

                {props.text && <span>{props.text}</span>}
            </Stack>
        </Button>
    );
}
